import PropTypes from 'prop-types';
import SelectOption from './_SelectOption';

const allowedInputTypes = [
  'text',
  'password',
  'number',
  'checkbox',
  'email',
  'radio',
  'date',
  'date-picker',
  'address',
  'select',
  'select-async',
  'search',
  'textarea'
];

const allowedTextAreaResizingOptions = [
  'horizontal',
  'vertical',
  'both',
  'none'
];

const allowedDescriptionType = function (props, propName, componentName) {
  const descriptionProp = props[propName];

  if (!descriptionProp) {
    return new Error(`Error: "description" property is required - in ${componentName}`);
  }

  if (props.type === 'checkbox' || props.type === 'radio') {
    const actualPropType = typeof (descriptionProp);
    const isElement = actualPropType === 'object' && descriptionProp.$$typeof !== undefined;

    if (!isElement && actualPropType !== 'string') {
      return new Error(
        `Error: invalid custom input prop: ${
          isElement ? '"element" or "string"' : 'string'
        } was expected but got "${actualPropType}" - in ${componentName}`
      );
    }
  }
};

const allowedSelectOptionTypes = [
  PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  }),
  PropTypes.instanceOf(SelectOption)
];

const allowedReactSelectValueTypes = [
  PropTypes.string,
  PropTypes.arrayOf(
    PropTypes.string
  )
];

export {
  allowedInputTypes,
  allowedTextAreaResizingOptions,
  allowedDescriptionType,
  allowedSelectOptionTypes,
  allowedReactSelectValueTypes
};